export default __webpack_public_path__ + "static/media/Frame11.c39b679a.png";